export const removeHashParams = (url) => {
  const hashIndex = url.indexOf('#');
  if (hashIndex !== -1) {
    const baseUrl = url.substring(0, hashIndex);
    return baseUrl;
  }
  return url;
};
